<template>
    <div class="loading-wrap">
        <div v-show="showAlert" class="back-wall-wrap">
            <img src="../../assets/img/bgimg.png" alt="back-wall">
        </div>
        <!-- 进度条背景层 -->
        <div v-show="!showAlert" class="progress-wrap-bg">
            <mu-circular-progress style="position:absolute;top: 45%;left: 50%;transform: translate(-50%,-50%);" mode="determinate" :strokeWidth="8" color="#EAF4FF" :size="180" :value="100"/>
        </div>
        <!-- 认知游戏进度条 -->
        <div v-show="!showAlert" class="progress-wrap-cogn">
            <mu-circular-progress style="position:absolute;top: 45%;left: 50%;transform: translate(-50%,-50%);" mode="determinate" :strokeWidth="8" color="#0A81E5" :size="180" :value="precent"/>
        </div>
        <!-- 言语游戏进度条 -->
        <div v-show="!showAlert" class="progress-wrap-lan">
            <mu-circular-progress style="position:absolute;top: 45%;left: 50%;transform: translate(-50%,-50%);" mode="determinate" :strokeWidth="8" color="#0A81E5" :size="180" :value="lanPercent"/>
        </div>
        <div class="medicine-wrap">
            <img v-if="showMedicine" class="medicine" id="medicine-pic" src="../../assets/img/medicine.png" alt="medicine">
            <img v-if="!showMedicine" src="../../assets/img/medicine_down.png" alt="medicine_down">
        </div>
        <div class="content-wrap">
            <p v-show="showAlert" style="position:absolute;left:50%;width:320px;transform:translateX(-50%);color:#999999;text-align:center;top:40px;">读取资源失败，可能因为您的网络不稳定，<br/>请点击“退出”后重试</p>
            <div class="precent" v-if="showCognPrecent">{{precent+"%"}}</div>
            <div class="precent" v-if="!showCognPrecent">{{lanPercent+"%"}}</div>
            <div class="loading">努力为您加载中，请耐心等候一下哦...</div>
            <div class="cancel-wrap">
                <button @click="cancel" class="cancel-btn">退出</button>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data(){
        return{
            showAlert:false,
            _t:"",
            _lant:"",
            count:0,
            precent:0,//认知游戏的进度条
            lanPercent:0,//言语游戏的进度条
            showCognPrecent:true,
            showMedicine:true,
        }
    },
    props:["type"],
    mounted(){
        if(this.type == 'cogn'){
            this.showCognPrecent = true;
        }else{
            this.showCognPrecent = false;
            this.lanLoading();
        }
        var self = this;
        var loading = document.querySelector(".loading-wrap");
        loading.style.width = document.body.clientWidth + "px";
        loading.style.height = document.body.clientHeight + "px";
        window.addEventListener("message",this.message,false);
        this._t = setInterval(function(){
            console.log(self.count);
            self.count++;
            if( self.count == 60 ){
                var btn = document.querySelector(".cancel-btn");
                btn.style.color = "#DF4646";
                btn.style.border = "1px solid #DF4646";
                self.showAlert = true;
                self.showMedicine = false;
                self.count = 0;
                clearInterval(self._t);
            }
        },1000)
    },
    methods:{
        lanLoading(){
            //言语游戏模拟加载进度
            var self = this;
            this._lant = setInterval(function(){
                self.lanPercent += 33;
                if(self.lanPercent > 90){
                    self.lanPercent = 99;
                }
            },1000)
        },
        cancel(){
            window.location.reload();
        },
        message(event){
            var val = event.data;
            if(val.action == "loading_fail"){
                this.showMedicine = false;
                this.showAlert = true;
                var btn = document.querySelector(".cancel-btn");
                btn.style.color = "#DF4646";
                btn.style.border = "1px solid #DF4646";
            }
            if(val.start_game === 'ok'){
                this.count = 0;
                clearInterval(this._t);
            }
            if(val.action == 'lan_start'){
                this.count = 0;
                this.lanPercent = 0;
                clearInterval(this._lant)
                clearInterval(this._t);
            }
            if(val.action == 'loading_count'){
                this.precent = val.count;
            }
        },
    },
    destroyed(){
        this.count = 0;
        this.lanPercent = 0;
        clearInterval(this._lant)
        clearInterval(this._t);
    }
}
</script>
<style scoped>
.loading-wrap{
    position: fixed;
    top:0;
    left:0;
    z-index:9999;
    background-color: #fff;
}
.logo-wrap{
    margin:20px 0px 0px 20px; 
}
.back-wall-wrap,.medicine-wrap,.content-wrap,.progress-wrap-bg,.progress-wrap-cogn,.progress-wrap-lan{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

.medicine-wrap,.progress-wrap-bg,.progress-wrap-cogn,.progress-wrap-lan{
    top: 45%;
}

.progress-wrap-bg,.progress-wrap-cogn,.progress-wrap-lan{
    transform: translate(-50%,-50%) rotate(-90deg);
}

.medicine{
    animation: circle 2s linear infinite;
    -webkit-animation: circle 2s linear infinite;
}

.medicine-stop{}

@-webkit-@keyframes circle
{
    0%   {transform: rotate(0deg);}
    50%  {transform: rotate(180deg);}
    100% {transform: rotate(360deg);}
}

@keyframes circle
{
    0%   {transform: rotate(0deg);}
    50%  {transform: rotate(180deg);}
    100% {transform: rotate(360deg);}
}
.loading{
    color: #151515;
    font-size:16px;
}

.precent{
    text-align: center;
    font-size: 24px;
    color:#0A81E5;
    margin-top:380px;
}

.content-wrap{
    width:600px;
    height:600px;
}
.loading{
    width:600px;
    text-align: center;
}

.cancel-btn{
    position:absolute;
    top: 480px;
    left:50%;
    transform:translateX(-50%);
    width:120px;
    height:36px;
    background-color:#fff;
    color:#999999;
    border-radius: 15px;
    border:1px solid #999999;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// loading.vue?034c16c1